// extracted by mini-css-extract-plugin
export default {"root":"ryoUgfQxbPjxNupJqa1_","placeHolderShimmer":"If1mMuU48WEH4vxBWwNP"};